import {IErrorResponseItem, ValidationError, ValidationErrors} from "../services/validator";
import { TransactionValidationField } from "./transactions";
import { IAmountDetailsFormState } from "../components/Transactions/Components/Form/Fields/AmountDetails/AmountDetailsField";
import { convertAmountToFloat } from "../helpers/transaction_helpers";
import { Currency } from "../config/currencies";
import { sumValues } from "../helpers/transaction_details_amount_details";

export type AmountDetailsValidation = {
    [key in TransactionValidationField]?: ValidationError[];
};

export type AmountDetailsValidationErrors = ValidationErrors<AmountDetailsValidation, TransactionValidationField>;

export const amountDetailsValidationFactory = (errors: IErrorResponseItem[]): AmountDetailsValidationErrors => {
    const v = new ValidationErrors<AmountDetailsValidation, TransactionValidationField>();
    v.setMap({
        amountDetails: TransactionValidationField.AMOUNT_DETAILS_TOTAL,
    });
    v.setErrors(errors);

    return v;
};

export const validateAmountDetailsForm = (data: IAmountDetailsFormState, amount: string | number, currency: Currency): AmountDetailsValidationErrors => {
    const errors = amountDetailsValidationFactory([]);

    const sum = sumValues(data);
    amount = convertAmountToFloat(amount);

    if (sum !== amount) {
        errors.add(TransactionValidationField.AMOUNT_DETAILS_TOTAL, (
            `The sum of the details (${(sum as any).toCurrency(currency)}) ` +
            `does not match the transaction amount (${(amount as any).toCurrency(currency)}).`
        ) as any);
    }

    return errors;
};
